module.exports = __webpack_public_path__ + "img/13.60a34878.jpg";